import { useState, useEffect, useRef } from "react";
import type { ITooltip } from "../../types/Tooltip";
import { getHorizontalPlacement, getVerticalPlacement } from "../../utils/getPlacement";
import styles from "./tooltip.module.scss";

export const Tooltip = ({
  children,
  text,
  hintText,
  triggerOn = 'hover',
  placement = 'auto',
  centerArrow = false, // in-case of the tooltip is triggered by small width element (ex: 'i' icon)
  handleMouseOver
}: ITooltip) => {

  const tooltipRef = useRef<any>();
  const tooltipWrapperRef = useRef<any>();

  const getAutoPlacement = () => {

    const htmlElement = document.documentElement;
    const htmlElementDir = htmlElement?.getAttribute("dir") || 'ltr';

    const verticalPlacement = getVerticalPlacement(tooltipWrapperRef);
    const horizontalPlacement = getHorizontalPlacement(tooltipWrapperRef, htmlElementDir as 'rtl' | 'ltr');

    const placement = `${verticalPlacement} ${horizontalPlacement}`;

    return placement;
  };

  const [visible, setVisible] = useState(false);
  const [autoPlacement, setAutoPlacement] = useState(getAutoPlacement());

  useEffect(() => {
    visible && setAutoPlacement(getAutoPlacement());
  }, [visible]);

  const onMouseOverHandler = () => {
    setVisible(true);
    handleMouseOver?.();
  };

  const onMouseOutHandler = () => setVisible(false);

  const onFocusHandler = () => setVisible(true);

  const onBlurHandler = () => setVisible(false);

  const triggerOnHover = triggerOn === 'hover';
  const triggerOnFocus = triggerOn === 'focus';

  const isTooltipEmpty = !text && !hintText;

  return (
    <div
      className={styles["tooltip-wrapper"]}
      ref={tooltipWrapperRef}
      data-tooltip-placement={placement === 'auto' ? autoPlacement : placement}
      data-tooltip-arrow-centered={centerArrow}
    >

      <div
        className={styles["tooltip-wrapper__trigger"]}
        tabIndex={0}
        onMouseOver={() => triggerOnHover && !isTooltipEmpty && onMouseOverHandler()}
        onMouseOut={() => triggerOnHover && !isTooltipEmpty && onMouseOutHandler()}
        onFocus={() => triggerOnFocus && !isTooltipEmpty && onFocusHandler()}
        onBlur={() => triggerOnFocus && !isTooltipEmpty && onBlurHandler()}
      >
        {children}
      </div>

      {
        ((text || hintText) && visible) &&
        <div
          ref={tooltipRef}
          className={styles["tooltip-wrapper__tooltip"]}
        >
          {text && <div className={styles["tooltip-wrapper__tooltip__text"]}>{text}</div>}
          {hintText && <div className={styles["tooltip-wrapper__tooltip__hint-text"]}>{hintText}</div>}
        </div>
      }
    </div>
  )
};